export const SERVER = {
  name: "Bone County Roleplay",
  short: "BCRP",
  ip: "212.73.137.40:22448",
  mtaLink: "mtasa://212.73.137.40:22448",
  discord: "https://discord.gg/HGJXNNcqfh",
  forum: "/forum",
  site: "https://bc-rp.hu",
  support: "https://vps4you.hu/smsgw.php?r=0&service=202121",
};

export const ASSETS = {
  logo: "/assets/bcrp_big.png",
  cover: "/assets/borito.png",
  heroBg: "/assets/hatter.png",
  authBg: "/assets/2b3113-9.jpg",
  screenshot: "/assets/mta-screen_2024-01-22_19-18-55.png",
};

export const NAV = [
  { label: "Hírek", href: "#hirek" },
  { label: "Galéria", href: "#galeria" },
  { label: "Fórum", href: SERVER.forum, route: true },
  { label: "Kapcsolat", href: "#kapcsolat" },
];

export const ABOUT = {
  eyebrow: "A szerverről röviden",
  title: "Bone County Roleplay",
  text: "Szerverünk ötlete 2026 elején született. Alapját a régi BCRP-mod adja, amelyet rengeteg újdonsággal és fejlesztéssel egészítünk ki.",
  facts: [
    { label: "Megnyitás", value: "2026. december" },
    { label: "Szerver verzió", value: "V1.0" },
  ],
};

export const LINKS = {
  eyebrow: "Linkek, csatlakozás",
  items: [
    { id: "mta", label: "MTA szerver csatlakozás", href: SERVER.mtaLink, meta: SERVER.ip },
    { id: "discord", label: "Discord szerver csatlakozás", href: SERVER.discord, meta: "discord.gg/HGJXNNcqfh", external: true },
    { id: "forum", label: "Átirányítás a fórumra", href: SERVER.forum, meta: "bc-rp.hu/forum", route: true },
  ],
};

export const NEWS = {
  eyebrow: "Hírek, újdonságok",
  items: [
    {
      id: "hibajavitasok",
      title: "Hibajavítások",
      date: "2026. május 20.",
      text: "A szerverünkön számos hibajavítást végeztünk el, hogy a játékélmény még stabilabb és élvezetesebb legyen minden játékos számára.",
    },
    {
      id: "tippmix",
      title: "Tippmix",
      date: "2026. július 23.",
      text: "Bekerült a tippmix valódi meccsekre is, így a játékosok most már valós eseményekre is fogadhatnak a szerveren.",
    },
    {
      id: "lotto",
      title: "Bekerült a lottó",
      date: "2026. július 28.",
      text: "Bevezetésre került a lottórendszer, amely lehetőséget ad a játékosoknak, hogy különböző nyereményeket nyerjenek. Hétköznaponként szelvényt vásárolhatnak, szombatonként pedig sorsolásra kerül sor.",
    },
    {
      id: "boltrendszer",
      title: "Új bolt rendszer",
      date: "2026. szeptember 15.",
      text: "Elkészült a bolt rendszer, ami minden játékosnak esélyt ad arra, hogy boltot üzemeltessen.",
    },
     {
      id: "repont",
      title: "REpont rendszer",
      date: "2026. szeptember 23.",
      text: "Elkészült a REpont-rendszer: minden elfogyasztott ital után üres üveget kapsz, amelyet a REpont-automatánál adhatsz le.",
    },
         {
      id: "bcring",
      title: "Bone Ring",
      date: "2026. szeptember 27.",
      text: "Elkészült a Bone Ring versenypálya, ahol a játékosok különböző autóversenyeken vehetnek részt. A pálya komppal közelíthető meg.",
    },
        {
      id: "kuka",
      title: "Kuka rendszer",
      date: "2026. szeptember 29.",
      text: "Elkészült a kuka rendszer, amely lehetővé teszi a játékosok számára, hogy a játék világában elhelyezett kukákban \"kincseket\" találjanak.",
    },
          {
      id: "vape",
      title: "Vape rendszer",
      date: "2026. szeptember 29.",
      text: "Elkészült a vape rendszer, ami lehetőséget ad hogy különböző tipusú/ízű vape-eket vásárolhassanak a játékosok.",
    },
  ],
};

export const SUPPORT = {
  title: "Támogatás",
  text: "Amennyiben támogatni szeretnéd a szervert, kattints az alábbi gombra.",
  cta: "Támogatás",
};

export const CONTACT = {
  eyebrow: "Kérdésed van? Írj nekünk",
  title: "Kapcsolat",
  text: "Ha segítségre van szükséged, hibát találtál, vagy bármilyen kérdésed van, írj nekünk e-mailben.",
  email: "support@bc-rp.hu",
};

export const MARQUEE = [
  "Bone County Roleplay",
  "Csatlakozz hozzánk még ma",
  "Hírek, újdonságok",
  "Fórum",
  "Discord",
  "V1.0",
];

export const GALLERY = [
  { src: "/assets/gallery/bone-county-ut.jpg", alt: "Bone County – sivatagi út" },
  { src: "/assets/gallery/texaco-benzinkut.png", alt: "Texaco benzinkút éjszaka" },
  { src: "/assets/gallery/borito.png", alt: "Bone County Roleplay borító" },
];

export const FOOTER = {
  copyright: "© 2026 BC-RP.HU - Minden jog fenntartva!",
  credit: "A weboldalt készítette sTVAN",
};
